var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[(!this.$route.meta.HideHeader)?_c('div',[_c('app-header'),_c('app-layout')],1):_c('div',{staticClass:"fill-height"},[_c('v-content',[_c('router-view')],1)],1),(!this.$route.meta.guest)?_c('app-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }